<template>
  <div>
    <textarea class="form-control flex-stretch" v-model="currentContent"></textarea>
  </div>
</template>
<script>
export default {
  props: ['content'],
  data() {
    return {
      currentContent: ''
    }
  },
  created() {
    this.currentContent = this.content
  },
  watch: {
    currentContent() {
      this.$emit('update', this.currentContent)
    }
  }
}
</script>
<style scoped lang="scss">
textarea {
  width: 100%;
  height: 100%;
  font-family: "Courier New", Courier, monospace;
  white-space: pre-wrap;
  font-size: 0.9rem;
}
.form-control:focus {
  outline: none;
  box-shadow: none;
  border-color: $input-border-color;
}
</style>
